export default __webpack_public_path__ + "static/media/001-W-divorcee.f44628b7.svg";